import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { LineChartConfig } from '../../types/executiveChat';
import './ChartCard.css';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface LineChartCardProps {
  config: LineChartConfig;
}

const LineChartCard: React.FC<LineChartCardProps> = ({ config }) => {
  // Extract labels from data
  const labels = config.data.map(item => item[config.xAxisKey]);

  // Build datasets from lines configuration
  const datasets = config.lines.map(line => ({
    label: line.name,
    data: config.data.map(item => item[line.dataKey]),
    borderColor: line.color,
    backgroundColor: line.color + '20', // Add transparency
    tension: 0.3,
    fill: false,
    pointRadius: 4,
    pointHoverRadius: 6,
    borderWidth: 2
  }));

  const chartData = {
    labels,
    datasets
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12,
            family: "'Inter', sans-serif"
          }
        }
      },
      tooltip: {
        mode: 'index' as const,
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: {
          size: 13,
          weight: 'bold' as const
        },
        bodyFont: {
          size: 12
        },
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const value = context.parsed.y;
            // Format large numbers with commas
            label += value.toLocaleString();
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            // Format large numbers
            if (value >= 1000000) {
              return (value / 1000000).toFixed(1) + 'M';
            } else if (value >= 1000) {
              return (value / 1000).toFixed(0) + 'K';
            }
            return value;
          },
          font: {
            size: 11
          }
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        ticks: {
          font: {
            size: 11
          }
        },
        grid: {
          display: false
        }
      }
    },
    interaction: {
      mode: 'nearest' as const,
      axis: 'x' as const,
      intersect: false
    }
  };

  return (
    <div className="exec-chart-card">
      {config.title && <h3 className="exec-chart-title">{config.title}</h3>}
      <div className="exec-chart-container">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default LineChartCard;














